import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function SubscriptionMode() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* 第一區塊：主視覺標題 */}
      <div className="bg-stone-900 pt-20 pb-16">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <Navbar />
          <div className="mt-10 text-center">
            <h1
              className="font-body text-3xl md:text-5xl font-bold text-white tracking-wide"
              style={{ lineHeight: 1.3, letterSpacing: "0.03em" }}
            >
              認購指南
            </h1>
            <p className="font-body text-sm md:text-base text-stone-400 mt-4 max-w-xl mx-auto leading-relaxed">
              了解認購批發的完整流程，新手也能輕鬆上手
            </p>
          </div>
        </div>
      </div>

      {/* 第二區塊：核心說明 */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block font-body text-xs font-semibold px-4 py-1.5 rounded-full bg-amber-50 text-amber-800 tracking-wider">
            認購批發
          </span>
          <h2
            className="font-body text-xl md:text-3xl font-bold text-stone-800 mt-5"
            style={{ lineHeight: 1.3 }}
          >
            1. 什麼是認購？
          </h2>
          <p className="font-body text-sm md:text-base text-stone-500 mt-3">
            認購就是買賣貨權，一起合夥做生意
          </p>
        </div>
      </section>

      {/* 第三區塊：精緻圖文卡片 */}
      <section className="w-full px-4 md:px-8 lg:px-12 pb-14 md:pb-20">
        <div className="max-w-lg mx-auto">
          <div className="bg-white rounded-xl border border-stone-200 p-8 md:p-10 text-center">
            {/* 黃色小圖標 */}
            <div className="w-16 h-16 rounded-2xl bg-amber-50 flex items-center justify-center mx-auto">
              <i className="ri-coins-line text-amber-500 text-2xl" />
            </div>
            <h3 className="font-body text-lg font-bold text-stone-800 mt-5">
              認購
            </h3>
            <p className="font-body text-sm text-stone-500 mt-3 leading-relaxed">
              我手上有與大廠對接好的實體產品，產品一律放在此平台上，妳只需點擊產品、決定組數、支付成本，即可把這批貨的所有權買下來。
            </p>
          </div>
        </div>

        {/* 三張新增卡片 */}
        <div className="max-w-5xl mx-auto mt-10 md:mt-14">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {/* 卡片一：代售 */}
            <div className="bg-white rounded-xl border border-stone-200 p-8 md:p-10 text-center">
              <div className="w-16 h-16 rounded-2xl bg-amber-50 flex items-center justify-center mx-auto">
                <i className="ri-shopping-bag-line text-amber-500 text-2xl" />
              </div>
              <h3 className="font-body text-lg font-bold text-stone-800 mt-5">
                代售
              </h3>
              <p className="font-body text-sm text-stone-500 mt-3 leading-relaxed">
                主打免囤貨，提供沒有資源、客源、貨源的人，讓每一個人都可以輕鬆享有網拍所做的事情，並從中獲取利潤，且你完全不需要煩惱這些風險事項。
              </p>
            </div>

            {/* 卡片二：銷售管道 */}
            <div className="bg-white rounded-xl border border-stone-200 p-8 md:p-10 text-center">
              <div className="w-16 h-16 rounded-2xl bg-amber-50 flex items-center justify-center mx-auto">
                <i className="ri-global-line text-amber-500 text-2xl" />
              </div>
              <h3 className="font-body text-lg font-bold text-stone-800 mt-5">
                銷售管道
              </h3>
              <p className="font-body text-sm text-stone-500 mt-3 leading-relaxed">
                銷售將會到國內外各大通路，商品一律堅持熱銷、低價、利潤可觀為前提進行。
              </p>
            </div>

            {/* 卡片三：利潤入帳 */}
            <div className="bg-white rounded-xl border border-stone-200 p-8 md:p-10 text-center">
              <div className="w-16 h-16 rounded-2xl bg-amber-50 flex items-center justify-center mx-auto">
                <i className="ri-wallet-3-line text-amber-500 text-2xl" />
              </div>
              <h3 className="font-body text-lg font-bold text-stone-800 mt-5">
                利潤入帳
              </h3>
              <p className="font-body text-sm text-stone-500 mt-3 leading-relaxed">
                商品一售出，你持有貨物權，利潤與成本當下立即結算給你。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 第四區塊：如何參與認購 */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-stone-50">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block font-body text-xs font-semibold px-4 py-1.5 rounded-full bg-emerald-50 text-emerald-700 tracking-wider">
            參與流程
          </span>
          <h2
            className="font-body text-xl md:text-3xl font-bold text-stone-800 mt-5"
            style={{ lineHeight: 1.3 }}
          >
            2. 如何參與認購？
          </h2>
          <p className="font-body text-sm md:text-base text-stone-500 mt-3">
            三步驟開啟你的認購之旅
          </p>
        </div>

        <div className="max-w-4xl mx-auto mt-10 md:mt-14 space-y-5">
          {/* Step 1 */}
          <div className="bg-white rounded-xl border border-stone-200 p-6 md:p-8 flex flex-col md:flex-row items-start gap-5">
            <div className="w-14 h-14 rounded-2xl bg-emerald-50 flex items-center justify-center shrink-0">
              <i className="ri-vip-crown-line text-emerald-600 text-2xl" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="inline-block font-body text-[10px] font-bold px-2 py-0.5 rounded bg-emerald-600 text-white uppercase tracking-wider">
                  Step 1
                </span>
                <h3 className="font-body text-base font-bold text-stone-800">
                  成為VIP
                </h3>
              </div>
              <p className="font-body text-sm text-stone-500 mt-2 leading-relaxed">
                參與搶標來開啟你的VIP權限，決定你想購入的商品品項。
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="bg-white rounded-xl border border-stone-200 p-6 md:p-8 flex flex-col md:flex-row items-start gap-5">
            <div className="w-14 h-14 rounded-2xl bg-emerald-50 flex items-center justify-center shrink-0">
              <i className="ri-shopping-cart-line text-emerald-600 text-2xl" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="inline-block font-body text-[10px] font-bold px-2 py-0.5 rounded bg-emerald-600 text-white uppercase tracking-wider">
                  Step 2
                </span>
                <h3 className="font-body text-base font-bold text-stone-800">
                  平台選商品
                </h3>
              </div>
              <p className="font-body text-sm text-stone-500 mt-2 leading-relaxed">
                登入這個平台系統，依照你的預算以及收益期望值，挑選你想認購的產品。
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="bg-white rounded-xl border border-stone-200 p-6 md:p-8 flex flex-col md:flex-row items-start gap-5">
            <div className="w-14 h-14 rounded-2xl bg-emerald-50 flex items-center justify-center shrink-0">
              <i className="ri-wallet-3-line text-emerald-600 text-2xl" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="inline-block font-body text-[10px] font-bold px-2 py-0.5 rounded bg-emerald-600 text-white uppercase tracking-wider">
                  Step 3
                </span>
                <h3 className="font-body text-base font-bold text-stone-800">
                  支付成本
                </h3>
              </div>
              <p className="font-body text-sm text-stone-500 mt-2 leading-relaxed">
                挑選完後點擊立即認購，可洽詢供應商後，待商品準備完善，即可開始銷售，銷售完畢利潤成本進帳。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 第五區塊：為什麼選擇我們 */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block font-body text-xs font-semibold px-4 py-1.5 rounded-full bg-rose-50 text-rose-700 tracking-wider">
            認購優勢
          </span>
          <h2
            className="font-body text-xl md:text-3xl font-bold text-stone-800 mt-5"
            style={{ lineHeight: 1.3 }}
          >
            3. 為什麼選擇我們？
          </h2>
        </div>

        <div className="max-w-6xl mx-auto mt-10 md:mt-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
            {/* 卡片一：專業把關，安心成交 */}
            <div className="bg-white rounded-xl border border-stone-200 p-7 md:p-8 text-center">
              <div className="w-14 h-14 rounded-2xl bg-rose-50 flex items-center justify-center mx-auto">
                <i className="ri-shield-check-line text-rose-500 text-2xl" />
              </div>
              <h3 className="font-body text-sm font-bold text-stone-800 mt-4">
                專業把關，安心成交
              </h3>
              <p className="font-body text-xs text-stone-500 mt-2 leading-relaxed">
                所有商品皆經過市場篩選與品質評估，提升購買信任感。
              </p>
            </div>

            {/* 卡片二：輕鬆分享，降低囤貨壓力 */}
            <div className="bg-white rounded-xl border border-stone-200 p-7 md:p-8 text-center">
              <div className="w-14 h-14 rounded-2xl bg-rose-50 flex items-center justify-center mx-auto">
                <i className="ri-home-3-line text-rose-500 text-2xl" />
              </div>
              <h3 className="font-body text-sm font-bold text-stone-800 mt-4">
                輕鬆分享，降低囤貨壓力
              </h3>
              <p className="font-body text-xs text-stone-500 mt-2 leading-relaxed">
                不需大量備貨，也不用自行處理繁瑣流程，更容易開始。
              </p>
            </div>

            {/* 卡片三：低門檻經營，更容易開始 */}
            <div className="bg-white rounded-xl border border-stone-200 p-7 md:p-8 text-center">
              <div className="w-14 h-14 rounded-2xl bg-rose-50 flex items-center justify-center mx-auto">
                <i className="ri-rocket-line text-rose-500 text-2xl" />
              </div>
              <h3 className="font-body text-sm font-bold text-stone-800 mt-4">
                低門檻經營，更容易開始
              </h3>
              <p className="font-body text-xs text-stone-500 mt-2 leading-relaxed">
                不必自行出貨，經營更輕鬆。
              </p>
            </div>

            {/* 卡片四：嚴選商品，提升成交率 */}
            <div className="bg-white rounded-xl border border-stone-200 p-7 md:p-8 text-center">
              <div className="w-14 h-14 rounded-2xl bg-rose-50 flex items-center justify-center mx-auto">
                <i className="ri-star-smile-line text-rose-500 text-2xl" />
              </div>
              <h3 className="font-body text-sm font-bold text-stone-800 mt-4">
                嚴選商品，提升成交率
              </h3>
              <p className="font-body text-xs text-stone-500 mt-2 leading-relaxed">
                協助挑選市場接受度高的商品，減少踩雷風險。
              </p>
            </div>

            {/* 卡片五：制度透明，收益看得見 */}
            <div className="bg-white rounded-xl border border-stone-200 p-7 md:p-8 text-center">
              <div className="w-14 h-14 rounded-2xl bg-rose-50 flex items-center justify-center mx-auto">
                <i className="ri-file-list-3-line text-rose-500 text-2xl" />
              </div>
              <h3 className="font-body text-sm font-bold text-stone-800 mt-4">
                制度透明，收益看得見
              </h3>
              <p className="font-body text-xs text-stone-500 mt-2 leading-relaxed">
                訂單與收益皆有紀錄，流程公開清楚。
              </p>
            </div>
          </div>

          {/* 結論文字 */}
          <div className="mt-12 md:mt-16 text-center">
            <h3 className="font-body text-lg md:text-xl font-bold text-stone-800">
              為什麼很多人選擇加入？
            </h3>
            <p className="font-body text-sm text-stone-500 mt-2">
              商品有人把關，更有信心
            </p>
          </div>
        </div>
      </section>

      {/* 第六區塊：認購保障與週期 */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-stone-50">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block font-body text-xs font-semibold px-4 py-1.5 rounded-full bg-sky-50 text-sky-700 tracking-wider">
            保障機制
          </span>
          <h2
            className="font-body text-xl md:text-3xl font-bold text-stone-800 mt-5"
            style={{ lineHeight: 1.3 }}
          >
            4. 認購保障與週期
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mt-10 md:mt-14 space-y-5">
          {/* 保障 1 */}
          <div className="bg-white rounded-xl border border-stone-200 p-6 md:p-8 flex flex-col md:flex-row items-start gap-5">
            <div className="w-14 h-14 rounded-2xl bg-sky-50 flex items-center justify-center shrink-0">
              <i className="ri-time-line text-sky-600 text-2xl" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="inline-block font-body text-[10px] font-bold px-2 py-0.5 rounded bg-sky-600 text-white uppercase tracking-wider">
                  保障 1
                </span>
                <h3 className="font-body text-base font-bold text-stone-800">
                  認購的保障
                </h3>
              </div>
              <p className="font-body text-sm text-stone-500 mt-2 leading-relaxed">
                提領3~5分鐘到帳。
              </p>
            </div>
          </div>

          {/* 保障 2 */}
          <div className="bg-white rounded-xl border border-stone-200 p-6 md:p-8 flex flex-col md:flex-row items-start gap-5">
            <div className="w-14 h-14 rounded-2xl bg-sky-50 flex items-center justify-center shrink-0">
              <i className="ri-bar-chart-line text-sky-600 text-2xl" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="inline-block font-body text-[10px] font-bold px-2 py-0.5 rounded bg-sky-600 text-white uppercase tracking-wider">
                  保障 2
                </span>
                <h3 className="font-body text-base font-bold text-stone-800">
                  資產透明，隨時查看
                </h3>
              </div>
              <p className="font-body text-sm text-stone-500 mt-2 leading-relaxed">
                資產透明，銷售進度可隨時查看。
              </p>
            </div>
          </div>

          {/* 保障 3 */}
          <div className="bg-white rounded-xl border border-stone-200 p-6 md:p-8 flex flex-col md:flex-row items-start gap-5">
            <div className="w-14 h-14 rounded-2xl bg-sky-50 flex items-center justify-center shrink-0">
              <i className="ri-shield-check-line text-sky-600 text-2xl" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="inline-block font-body text-[10px] font-bold px-2 py-0.5 rounded bg-sky-600 text-white uppercase tracking-wider">
                  保障 3
                </span>
                <h3 className="font-body text-base font-bold text-stone-800">
                  專業領航，風險規避
                </h3>
              </div>
              <p className="font-body text-sm text-stone-500 mt-2 leading-relaxed">
                每一項產品都經過團隊嚴格篩選，確保是市場熱銷貨才開放認購。妳負責參與，我負責讓這批貨在各大通路流轉。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 第七區塊：引導行動 CTA */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-body text-2xl md:text-4xl font-bold text-stone-800">
            準備好開始認購了嗎？
          </h2>
          <p className="font-body text-sm md:text-base text-stone-400 mt-4 leading-relaxed">
            前往產品列表挑選心儀商品，開啟你的認購批發之之旅
          </p>

          <a
            href="/shop"
            className="inline-flex items-center justify-center gap-2 w-full mt-8 font-body text-sm md:text-base font-bold text-white bg-orange-500 hover:bg-orange-600 transition-colors rounded-xl px-6 py-4 whitespace-nowrap"
          >
            <i className="ri-shopping-bag-line text-lg" />
            瀏覽產品
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}